/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-29 10:49:19
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title5 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P5 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;

    return (
      <Stage>
        <Title5 pageNumber="1.2">单月对比数据概览</Title5>

        <div className={s.content}>
          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: '100%', height: '100%' }}
              formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <Chart options={setChart({ label: chartTitle, list: chartList, color: chartColorList })} />
            </TooltipDrawer>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P5);



// WEBPACK FOOTER //
// src/routes/visualChart/P5/index.js